export const useLiveClockStore = defineStore('liveClock', () => {
  const currentTimestamp = useTimestamp({ interval: 1000 })

  return { currentTimestamp }
})
